module.exports = __webpack_public_path__ + "static/media/end.b927e101.svg";